import { TFunction } from 'i18next';

/**
 * Map practice area names to localization keys
 */
export const getPracticeAreaLocalizationKey = (practiceArea: string | null | undefined): string => {
  if (!practiceArea) return '';
  const keyMap: Record<string, string> = {
    'Accounting': 'accounting',
    'Anti-Money Laundering': 'anti_money_laundering',
    'Company Formation / Incorporation': 'company_formation',
    'Compliance and Regulatory': 'compliance_regulatory',
    'Corporate Services': 'corporate_services',
    'Corporate Tax': 'corporate_tax',
    'Cross-Border Estates': 'cross_border_estates',
    'Estate Planning': 'estate_planning',
    'Family Office': 'family_office',
    'Immigration and Visa': 'immigration_visa',
    'International Tax': 'international_tax',
    'Personal Tax': 'personal_tax',
    'Succession Planning': 'succession_planning',
    'Tax Advisory': 'tax_advisory',
    'Tax Compliance': 'tax_compliance',
    'Tax Dispute Resolution': 'tax_dispute_resolution',
    'Tax Planning': 'tax_planning',
    'Tax Services': 'tax_services',
    'Transfer Pricing': 'transfer_pricing',
    'Trusts Planning and Formation': 'trusts_planning',
    'Wealth Management': 'wealth_management',
    'Wills and Probate': 'wills_probate',
    // New practice areas from firm_type migration
    'Legal Services': 'legal_services',
    'Banking / Private Banking': 'banking_private_banking',
    'Consulting': 'consulting',
    'Insurance': 'insurance',
    'Investment Management': 'investment_management',
    'Financial Advisory': 'financial_advisory',
    'Real Estate': 'real_estate',
    'Will Writing': 'will_writing',
    'Academic / Research': 'academic_research',
    'Public Sector': 'public_sector',
    'Non-Profit / Charity': 'non_profit_charity',
    'Other': 'other',
  };

  return keyMap[practiceArea] || 'other';
};


/**
 * Localize practice area using i18next
 */
export const localizePracticeArea = (practiceArea: string | null | undefined, t: TFunction): string => {
  if (!practiceArea) return '';
  
  const key = getPracticeAreaLocalizationKey(practiceArea);
  return t(`components:practice_areas.${key}`, { defaultValue: practiceArea });
};
